import { getPurchaseGlobalHref } from "app/common/hrefs";
import { DEFAULT_HOMEPAGES } from "app/components/modals/constants";
import { allTrackers } from "app/services/track/track";

import type { ICurrency, IPackagesPrice } from "./types";
import { getAvailableCurrencies, getCurrency, getDefaultCurrency, getDefaultPaymentPeriod } from "./utils";

const DEFAULT_CURRENCY = "USD";
const AVAILABLE_CURRENCIES = ["USD"];

const TRACKING_EVENTS = {
    category: "Package",
    actionClick: "click",
} as const;

const PURCHASE_PARAMS = {
    delayPayment: "true",
} as const;

export const usePackagePurchase = (packages?: IPackagesPrice | null) => {
    const currencyCodes = packages ? getAvailableCurrencies(packages, AVAILABLE_CURRENCIES) : [];
    const defaultCurrency = getDefaultCurrency(currencyCodes, DEFAULT_CURRENCY);
    const defaultPaymentPeriod = getDefaultPaymentPeriod();
    const currentCurrency: ICurrency = getCurrency(defaultCurrency);

    const onSubmitStep = (packageId: string) => {
        const queryParams = new URLSearchParams({
            workspace: DEFAULT_HOMEPAGES.DMI,
            currency: currentCurrency.code,
            package: packageId,
            period: defaultPaymentPeriod,
            delayPayment: PURCHASE_PARAMS.delayPayment,
        });
        allTrackers.dispatchTrackEvent(
            TRACKING_EVENTS.category,
            TRACKING_EVENTS.actionClick,
            `choose package/${packageId}/${defaultPaymentPeriod}`,
        );

        window.open(`${getPurchaseGlobalHref()}?${queryParams}`);
    };

    return {
        currentCurrency,
        defaultPaymentPeriod,
        onSubmitStep,
    };
};
